module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_5.4a908070.pdf";